import { copyComponentToClipBoard } from "../../../../lib/designer/utils/copyAndPasteComponent";
import { readClipboard } from "../../../../lib/utils";
import { debounce, pick } from "lodash-es";
import Vue from 'vue';
import { isFirefox, isSafari } from "../../../../lib/utils/browser/clipboard";
const MESSAGE_DURATION = 0.5;
const clipboardData = Vue.observable({
  data: ''
});
const knownUcRoots = new Set();
const syncClipBoard = debounce(async () => {
  const txt = await readClipboard();
  if (txt !== clipboardData.data) {
    clipboardData.data = txt;
  }
}, 500);
const bindEvents = ['focus', 'copy', 'click'];
export function copyAction(list, ctx) {
  const {
    designer,
    layout,
    modifyComp,
    uc
  } = ctx;
  // 整个浏览器界面公用一个事件处理  && safari上不自动读取剪贴板 && firefox 上不自动读取剪贴板
  if (!knownUcRoots.has(designer) && !isSafari && !isFirefox) {
    if (!knownUcRoots.size) {
      bindEvents.forEach(k => window.document.addEventListener(k, syncClipBoard, true));
    }
    knownUcRoots.add(designer);
    designer.$once('hook:beforeDestroy', () => {
      knownUcRoots.delete(designer);
      if (!knownUcRoots.size) {
        bindEvents.forEach(k => window.document.removeEventListener(k, syncClipBoard, true));
      }
    });
  }
  list.push({
    title: '复制',
    place: ['propPanel'],
    icon: 'fa fa-copy',
    execute: async () => {
      copyComponentToClipBoard(designer);
      uc.$message.success('已复制组件', MESSAGE_DURATION);
      syncClipBoard();
    }
  });
  const getPasteActions = () => {
    const txt = clipboardData.data;
    let payload;
    if (!txt) return;
    try {
      payload = JSON.parse(txt);
    } catch (e) {}
    if (!payload) return;
    const {
      comp
    } = payload;
    if (!comp) return;
    const genCopyPropsAction = () => {
      if (!payload.copyProps) return;
      const {
        type,
        props
      } = comp;
      // 必须是相同组件
      if (layout.type !== type) return;
      if (!props) return;
      list.push({
        title: '粘贴属性',
        place: ['contextMenu', 'propPanel'],
        icon: 'fa fa-paint-brush',
        execute: async () => {
          await modifyComp({
            props
          });
          uc.$message.success('已粘贴组件属性', MESSAGE_DURATION);
        }
      });
    };
    const genCopyStylesAction = () => {
      if (!payload.copyStyles) return;
      const STYLE_KEYS = ['style', 'extraStyle', 'inlineStyleProps', 'styleSheetName'];
      const hasStyle = STYLE_KEYS.some(key => comp[key]);
      if (!hasStyle) return;
      list.push({
        title: '粘贴样式',
        place: ['contextMenu', 'propPanel'],
        icon: 'fa fa-paint-brush',
        execute: async () => {
          await modifyComp(pick(comp, STYLE_KEYS));
          uc.$message.success('已粘贴组件样式', MESSAGE_DURATION);
        }
      });
    };
    genCopyPropsAction();
    genCopyStylesAction();
  };
  getPasteActions();
  return list;
}